import classNames from 'classnames';
import { isFuture, parseISO } from 'date-fns';
import { useMemo, VFC } from 'react';

import { V2CreationData } from '@/apis/aniftyBackend/creations/interface';
import LockIcon from '@/icons/lock-icon.svg';
import getThumbnailURL from '@/utils/getThumbnailURL';

import styles from './SquareCreationThumbnail.module.scss';

type Props = {
  creation: V2CreationData;
  size?: number;
  className?: string;
};

const SquareCreationThumbnail: VFC<Props> = ({
  creation,
  size = 150,
  className = '',
}: Props) => {
  const thumbnailURL = useMemo(
    () =>
      getThumbnailURL(creation.imageURL, {
        cropSize: creation.cropSize,
        cropStartX: creation.cropStartX,
        cropStartY: creation.cropStartY,
        width: creation.width,
        height: creation.height,
      }),
    [creation]
  );

  const isReserved =
    creation.reservedAt && isFuture(parseISO(creation.reservedAt));

  return (
    <figure
      className={classNames(
        styles.creationThumbnail,
        {
          [styles.isReserved]: isReserved,
        },
        className
      )}
      style={{ width: size, height: size }}
    >
      <img src={thumbnailURL} alt="creation thumbnail" />

      {isReserved && (
        <div className={styles.reservedItemOverlay}>
          <LockIcon />
        </div>
      )}
    </figure>
  );
};

export default SquareCreationThumbnail;
